import { HeaderDrawer } from '../CustomUi/headerGaveta'
import Carregando from '../CustomUi/loading'
import { Render } from '../CustomUi/render'
import { BodyDrawer } from './styles'
import Tabs from '../Tabs'
import { faFlask, faPills, faSeedling } from '@fortawesome/free-solid-svg-icons'
import { FormDadosFertilizante } from './components/formDadosFertilizante'
import { FormElementos } from './components/formElementos'
import { ParamsFormulacao, ParamsMarca } from '../../services/fertilizante/GET'
import { FormDoses } from './components/formDoses'
import { SetStateAction } from 'react'
interface PropsFormFertilizante {
  loadingForm: boolean
  update: number
  tab_selecionar_atual: string
  setTab_selecionar_atual: React.Dispatch<React.SetStateAction<string>>
  nome: string
  setNome: React.Dispatch<React.SetStateAction<string>>
  observacao: string
  setObservacao: React.Dispatch<React.SetStateAction<string>>
  extratoAlga: string
  setExtratoAlga: React.Dispatch<React.SetStateAction<string>>
  extrato_de_alga_descricao: string
  setExtrato_de_alga_descricao: React.Dispatch<React.SetStateAction<string>>
  densidade: string
  setDensidade: React.Dispatch<React.SetStateAction<string>>
  aminoacido: string
  setAminoacido: React.Dispatch<React.SetStateAction<string>>
  solubilidade: string
  setSolubilidade: React.Dispatch<React.SetStateAction<string>>
  concentracao_hormonio_regulador: string
  setConcentracao_hormonio_regulador: React.Dispatch<React.SetStateAction<string>>
  descricao_hormonio_regulador: string
  setDescricao_hormonio_regulador: React.Dispatch<React.SetStateAction<string>>
  concentracao_aminoacido: string
  setConcentracao_aminoacido: React.Dispatch<React.SetStateAction<string>>
  descricao_aminoacido: string
  setDescricao_aminoacido: React.Dispatch<React.SetStateAction<string>>
  concentracao_indutor_resistencia: string
  setConcentracao_indutor_resistencia: React.Dispatch<React.SetStateAction<string>>
  descricao_indutor_resistencia: string
  setDescricao_indutor_resistencia: React.Dispatch<React.SetStateAction<string>>
  concentracao_biologicos: string
  setConcentracao_Biologicos: React.Dispatch<React.SetStateAction<string>>
  descricao_biologicos: string
  setDescricao_Biologicos: React.Dispatch<React.SetStateAction<string>>
  ponto_deliquescencia: string
  setPonto_deliquescencia: React.Dispatch<React.SetStateAction<string>>
  indice_salino: string
  setIndice_salino: React.Dispatch<React.SetStateAction<string>>
  funcao: { descr: string; id: number; key?: number }[]
  setFuncao: React.Dispatch<React.SetStateAction<{ descr: string; id: number; key?: number }[]>>
  aplicaçoes: { descr: string; id: number; key?: number }[]
  setAplicaçoes: React.Dispatch<React.SetStateAction<{ descr: string; id: number; key?: number }[]>>
  formulacao: string
  setFormulacao: React.Dispatch<React.SetStateAction<string>>
  setFormulacaoId: React.Dispatch<React.SetStateAction<number>>
  marca: string
  setMarca: React.Dispatch<React.SetStateAction<string>>
  setMarcaId: React.Dispatch<React.SetStateAction<number>>
  nitrogenio: string
  setNitrogenio: React.Dispatch<React.SetStateAction<string>>
  fosforo: string
  setFosforo: React.Dispatch<React.SetStateAction<string>>
  potassio: string
  setPotassio: React.Dispatch<React.SetStateAction<string>>
  calcio: string
  setCalcio: React.Dispatch<React.SetStateAction<string>>
  magnesio: string
  setMagnesio: React.Dispatch<React.SetStateAction<string>>
  enxofre: string
  setEnxofre: React.Dispatch<React.SetStateAction<string>>
  boro: string
  setBoro: React.Dispatch<React.SetStateAction<string>>
  cobre: string
  setCobre: React.Dispatch<React.SetStateAction<string>>
  ferro: string
  setFerro: React.Dispatch<React.SetStateAction<string>>
  manganes: string
  setManganes: React.Dispatch<React.SetStateAction<string>>
  zinco: string
  setZinco: React.Dispatch<React.SetStateAction<string>>
  cobalto: string
  setCobalto: React.Dispatch<React.SetStateAction<string>>
  molibdenio: string
  setMolibdenio: React.Dispatch<React.SetStateAction<string>>
  niquel: string
  setNiquel: React.Dispatch<React.SetStateAction<string>>
  silicio: string
  setSilicio: React.Dispatch<React.SetStateAction<string>>
  selenio: string
  setSelenio: React.Dispatch<React.SetStateAction<string>>
  doseMax: string
  setDoseMax: React.Dispatch<React.SetStateAction<string>>
  doseMin: string
  setDoseMin: React.Dispatch<React.SetStateAction<string>>
  dosePadrao: string
  setDosePadrao: React.Dispatch<React.SetStateAction<string>>
  cultura: string
  setCultura: React.Dispatch<React.SetStateAction<string>>
  culturaId: number
  setCulturaId: React.Dispatch<React.SetStateAction<number>>
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number | string>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
  dosagens: {
    cod?: number | string
    cultura_nome: string
    cod_cultura: number
    dose: string | number
    min_dose: string | number
    max_dose: string | number
  }[]
  aminoacidoPossuiDados: boolean
  hormonioReguladorPossuiDados: boolean
  indutorResistenciaPossuiDados: boolean
  biologicosPosseuiDados: boolean
  extratoAlgaPossuiDados: boolean
  data_aplicacoes: any[]
  data_funcoes: any[]
  data_formulacao: ParamsFormulacao[]
  data_marca: ParamsMarca[]
  data_cultura: any[]
  editar: boolean
  duplicar: boolean
  cod_dose: number
  inserirDosesCultura: Function
  editarDoses: Function
  deletarDoses: Function
}

const FormFertilizante: React.FC<PropsFormFertilizante> = ({
  loadingForm,
  update,
  tab_selecionar_atual,
  setTab_selecionar_atual,
  nome,
  setNome,
  observacao,
  setObservacao,
  extratoAlga,
  setExtratoAlga,
  extrato_de_alga_descricao,
  setExtrato_de_alga_descricao,
  densidade,
  setDensidade,
  aminoacido,
  setAminoacido,
  solubilidade,
  setSolubilidade,
  concentracao_aminoacido,
  setConcentracao_aminoacido,
  concentracao_hormonio_regulador,
  setDescricao_hormonio_regulador,
  concentracao_biologicos,
  setConcentracao_Biologicos,
  concentracao_indutor_resistencia,
  setConcentracao_indutor_resistencia,
  descricao_aminoacido,
  setDescricao_aminoacido,
  descricao_biologicos,
  setDescricao_Biologicos,
  descricao_hormonio_regulador,
  setConcentracao_hormonio_regulador,
  descricao_indutor_resistencia,
  setDescricao_indutor_resistencia,
  ponto_deliquescencia,
  setPonto_deliquescencia,
  indice_salino,
  setIndice_salino,
  funcao,
  setFuncao,
  aplicaçoes,
  setAplicaçoes,
  formulacao,
  setFormulacao,
  setFormulacaoId,
  marca,
  setMarca,
  setMarcaId,
  nitrogenio,
  setNitrogenio,
  fosforo,
  setFosforo,
  potassio,
  setPotassio,
  calcio,
  setCalcio,
  magnesio,
  setMagnesio,
  enxofre,
  setEnxofre,
  boro,
  setBoro,
  cobre,
  setCobre,
  ferro,
  setFerro,
  manganes,
  setManganes,
  zinco,
  setZinco,
  cobalto,
  setCobalto,
  molibdenio,
  setMolibdenio,
  niquel,
  setNiquel,
  silicio,
  setSilicio,
  selenio,
  setSelenio,
  doseMax,
  setDoseMax,
  doseMin,
  setDoseMin,
  dosePadrao,
  setDosePadrao,
  cultura,
  setCultura,
  culturaId,
  setCulturaId,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
  setFake_loading,
  dosagens,
  aminoacidoPossuiDados,
  hormonioReguladorPossuiDados,
  indutorResistenciaPossuiDados,
  biologicosPosseuiDados,
  extratoAlgaPossuiDados,
  data_aplicacoes,
  data_funcoes,
  data_formulacao,
  data_marca,
  data_cultura,
  editar,
  duplicar,
  cod_dose,
  inserirDosesCultura,
  editarDoses,
  deletarDoses,
}) => {
  return (
    <>
      <HeaderDrawer>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {update > 0 ? 'Atualizar fertilizante' : 'Cadastrar fertilizante'}

          {/* <small style={{ opacity: '0.5', fontSize: '9px' }}>{criadoPorAtualizadoPor}</small> */}
        </div>
      </HeaderDrawer>
      <BodyDrawer>
        <Render condition={loadingForm}>
          <Carregando
            animation
            justifyContent='center'
            height={'500px'}
            legenda='Carregando informações...'
          />
        </Render>
        <Render condition={loadingForm === false}>
          <Tabs
            tabs={[
              { descricao: 'Dados do fertilizante', icone: faSeedling },
              { descricao: 'Elementos', icone: faFlask },
              { descricao: 'Doses', icone: faPills },
            ]}
            selecionado={tab_selecionar_atual}
            trackWidth={220}
            onChange={setTab_selecionar_atual}
          />
          {tab_selecionar_atual === 'Dados do fertilizante' && (
            <FormDadosFertilizante
              nome={nome}
              setNome={setNome}
              observacao={observacao}
              setObservacao={setObservacao}
              extratoAlga={extratoAlga}
              setExtratoAlga={setExtratoAlga}
              extrato_de_alga_descricao={extrato_de_alga_descricao}
              setExtrato_de_alga_descricao={setExtrato_de_alga_descricao}
              densidade={densidade}
              setDensidade={setDensidade}
              aminoacido={aminoacido}
              setAminoacido={setAminoacido}
              indice_salino={indice_salino}
              setIndice_salino={setIndice_salino}
              aplicaçoes={aplicaçoes}
              setAplicaçoes={setAplicaçoes}
              funcao={funcao}
              setFuncao={setFuncao}
              formulacao={formulacao}
              setFormulacao={setFormulacao}
              setFormulacaoId={setFormulacaoId}
              marca={marca}
              setMarca={setMarca}
              setMarcaId={setMarcaId}
              data_aplicacoes={data_aplicacoes}
              data_funcoes={data_funcoes}
              data_formulacao={data_formulacao}
              data_marca={data_marca}
              solubilidade={solubilidade}
              setSolubilidade={setSolubilidade}
              concentracao_hormonio_regulador={concentracao_hormonio_regulador}
              setConcentracao_hormonio_regulador={setConcentracao_hormonio_regulador}
              descricao_hormonio_regulador={descricao_hormonio_regulador}
              setDescricao_hormonio_regulador={setDescricao_hormonio_regulador}
              concentracao_aminoacido={concentracao_aminoacido}
              setConcentracao_aminoacido={setConcentracao_aminoacido}
              descricao_aminoacido={descricao_aminoacido}
              setDescricao_aminoacido={setDescricao_aminoacido}
              concentracao_indutor_resistencia={concentracao_indutor_resistencia}
              setConcentracao_indutor_resistencia={setConcentracao_indutor_resistencia}
              descricao_indutor_resistencia={descricao_indutor_resistencia}
              setDescricao_indutor_resistencia={setDescricao_indutor_resistencia}
              concentracao_biologicos={concentracao_biologicos}
              setConcentracao_Biologicos={setConcentracao_Biologicos}
              descricao_biologicos={descricao_biologicos}
              setDescricao_Biologicos={setDescricao_Biologicos}
              ponto_deliquescencia={ponto_deliquescencia}
              setPonto_deliquescencia={setPonto_deliquescencia}
              aminoacidoPossuiDados={aminoacidoPossuiDados}
              hormonioReguladorPossuiDados={hormonioReguladorPossuiDados}
              indutorResistenciaPossuiDados={indutorResistenciaPossuiDados}
              biologicosPosseuiDados={biologicosPosseuiDados}
              extratoAlgaPossuiDados={extratoAlgaPossuiDados}
              
            />
          )}

          {tab_selecionar_atual === 'Elementos' && (
            <FormElementos
              nitrogenio={nitrogenio}
              setNitrogenio={setNitrogenio}
              fosforo={fosforo}
              setFosforo={setFosforo}
              potassio={potassio}
              setPotassio={setPotassio}
              calcio={calcio}
              setCalcio={setCalcio}
              magnesio={magnesio}
              setMagnesio={setMagnesio}
              enxofre={enxofre}
              setEnxofre={setEnxofre}
              boro={boro}
              setBoro={setBoro}
              cobre={cobre}
              setCobre={setCobre}
              ferro={ferro}
              setFerro={setFerro}
              manganes={manganes}
              setManganes={setManganes}
              zinco={zinco}
              setZinco={setZinco}
              cobalto={cobalto}
              setCobalto={setCobalto}
              molibdenio={molibdenio}
              setMolibdenio={setMolibdenio}
              niquel={niquel}
              setNiquel={setNiquel}
              silicio={silicio}
              setSilicio={setSilicio}
              selenio={selenio}
              setSelenio={setSelenio}
            />
          )}

          {tab_selecionar_atual === 'Doses' && (
            <FormDoses
              doseMax={doseMax}
              setDoseMax={setDoseMax}
              doseMin={doseMin}
              setDoseMin={setDoseMin}
              dosePadrao={dosePadrao}
              setDosePadrao={setDosePadrao}
              cultura={cultura}
              setCultura={setCultura}
              culturaId={culturaId}
              setCulturaId={setCulturaId}
              dosagens={dosagens}
              dataCultura={data_cultura}
              inserirDosesCultura={inserirDosesCultura}
              editarDoses={editarDoses}
              deletarDoses={deletarDoses}
              editar={editar}
              cod_dose={cod_dose}
              confirmar_exclusao={confirmar_exclusao}
              setConfirmar_exclusao={setConfirmar_exclusao}
              id_item_atual={id_item_atual}
              setId_item_atual={setId_item_atual}
              nome_item_atual={nome_item_atual}
              setNome_item_atual={setNome_item_atual}
              fake_loading={fake_loading}
              setFake_loading={setFake_loading}
            />
          )}
        </Render>
      </BodyDrawer>
    </>
  )
}

export default FormFertilizante
